import Vue from 'vue'
import store from '../store/index.js'

Vue.directive('primission', {
  /**
   * 当被绑定元素插入到DOM时 */
  inserted (el, binding) {
    const functionClass = binding.value
    const { pagePrimission } = store.state.isLogin
    let hasPrimission = pagePrimission[functionClass]
    if (!hasPrimission) {
      el.parentNode ? el.parentNode.removeChild(el) : el.style.display = 'none'
    }
  }
})
